
@if (calendarEvents?.length > 0 && !loading) {
  <full-calendar #calendar [options]='calendarOptions'  deepChangeDetection="true" ></full-calendar>
}
<ng-template #iconTemplate let-users="users" let-multiple="multiple">
  <span class="calendar-ooo-icon" [ngClass]="multiple ? 'users' : ''" container="body" >
   <or-profile-image [showRole]="false" size="small" showPlus="true" [names]="users" showInitials="true" tooltipPlacement="bottom"></or-profile-image>
  </span>
</ng-template>